import { useMemo } from 'react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';
import SpeechBubbleBase from './SpeechBubbleBase';
import Assets from '../../assets/Assets';

type AnchorPosition = 'left_bottom' | 'right_bottom' | 'left_top' | 'right_top';
export type Props = {
	anchor: AnchorPosition;
	shadow?: boolean;
	fadeInDelay?: number;
	fadeInDuration?: number;
};

const textSpacing = {
	top: '12%',
	bottom: '12%',
	left: '14%',
	right: '14%'
};

const SpeechBubble: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children, anchor, ...otherProps } = props;

	const transform = useMemo<string | undefined>(() => {
		switch (anchor) {
			case 'right_bottom':
				return 'rotateY(180deg)';
			case 'left_top':
				return 'rotateX(180deg)';
			case 'right_top':
				return 'rotateY(180deg) rotateX(180deg)';
			case 'left_bottom':
			default:
				return undefined;
		}
	}, [anchor]);

	const transitionClassNames = useMemo<string | undefined>(() => {
		switch (anchor) {
			case 'right_bottom':
				return 'scale-in-from-right-bottom';
			case 'left_top':
				return 'scale-in-from-left-top';
			case 'right_top':
				return 'scale-in-from-right-top';
			case 'left_bottom':
				return 'scale-in-from-left-bottom';
			default:
				return undefined;
		}
	}, [anchor]);

	return (
		<SpeechBubbleBase
			src={Assets.images.speechBubbleLarge}
			transform={transform}
			textSpacing={textSpacing}
			transitionClassNames={transitionClassNames}
			{...otherProps}
		>
			{children}
		</SpeechBubbleBase>
	);
};

export default styled(SpeechBubble)<PositionAndSizeProps>(
	PositionAndSizeFromProps
);
